/*
TODO Change this into a hook so it can use React.useMemo.
An issue with this being included in useEffect dependency arrays was found during an accessibility change.  Because not
including it in the dependency array isn't currently causing any issues, it was decided to not refactor this component as
part of that change.  However, I'd like to document how this should maybe change.

This should probably become useIdProvider and should become something like:
const nextId = React.useRef(initialValue)
nextId.current = initialValue
return React.useMemo(()=>({
 get: () => {
    return nextId.current
  },
 ...
 }), [])
That way, nextId is set to the initialValue with every render, like it is now, but the object returned by this method
always stays the same between renders so it can more easily be used in dependency arrays.
 */
/**
 * Creates and returns a new IDProvider instance.
 *
 * @param {intialValue} initialValue - The initial value of the provider. This will be the first value returned from any 'get' functions. Defaults to 1.
 */
const getIdProvider = (initialValue = 1) => {
    let nextId = initialValue;
    return {
        get: () => {
            return nextId;
        },
        getAndIncrement: () => {
            const returnValue = nextId;
            nextId += 1;
            return returnValue;
        },
        getAndDecrement: () => {
            const returnValue = nextId;
            nextId -= 1;
            return returnValue;
        },
    };
};
export { getIdProvider };
